import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { platformAuthUrl } from '../../utils/utils';
import { handleLoginActivity, ONBOARDING_ROUTES } from '../../stores/session-status';
import * as SessionActions from '../../stores/actions/session';
import { GreenroomState as GS } from '../../stores/types/types';
import DeviceAuth from '../device-auth/device-auth';
import queryString from 'query-string';

export default function SignInPresenter() {
	const invitation = useSelector((state: GS) => state.SessionReducer.invitation);
	const invitationError = useSelector((state: GS) => state.SessionReducer.invitationError);
	const token = useSelector((state: GS) => state.SessionReducer.token);
	const signInError = useSelector((state: GS) => state.SessionReducer.signInError);
	const shouldRefresh = useSelector((state: GS) => state.SessionReducer.shouldRefresh);
	const verifying = useSelector((state: GS) => state.SessionReducer.verifying);
	const {deviceAuth} = queryString.parse(window.location.search);
	const dispatch = useDispatch();

	useEffect(() => {
		if (token) {
			if (shouldRefresh) {
				// Anytime a presenter signs in we refresh the page. This refresh logic was
				// originally created because it was simpler to refresh the page when a producer
				// successfully signed in for a meeting than it was to modify the state.
				// Next page state is handled in session-status.ts on refresh
				window.location.reload();
			} else if (invitation) {
				dispatch(SessionActions.checkInvitation(token, invitation));
			} else {
				// if loading app and have token, default to select meeting view
				dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRESENTER_SELECT_MEETING));
			}
			// This logic normally runs in checkStatus, but we have to run it
			// here because presenters do not refresh when they login.
			handleLoginActivity(token, undefined);
		}
	}, [token, invitation, shouldRefresh]);

	function submitForm(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
	}

	function createAccount() {
		dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRESENTER_CREATE_ACCOUNT));
	}

	const logInPlatformAuth = (): void => {
		window.location.href = platformAuthUrl();
	};

	return (
		<div className="panel teal-green sign-in">

			{verifying
				? <h2>Verifying your account...</h2>
				:				<>
					<form onSubmit={submitForm}>
						<div className="presenter-message-container">
							<h2>You are about to log into the Greenroom as a Presenter</h2>
						</div>

						{signInError && (
							<>
								<div className="signin-error">
									<p>{typeof signInError !== 'string' ? signInError?.message : signInError}</p>
								</div>
							</>
						)}

						{invitationError && (
							<div className="signin-error">
								<p>
									It appears that this invitation does not match your account.
									Please sign in with a different account or check your invitation link
									and try again.
								</p>
							</div>
						)}

						<button className="onboarding" onClick={logInPlatformAuth}>
							Log in
						</button>

						<div className="create-account">
							<span>Not registered yet?</span><button onClick={createAccount} className="clickable">Create new account</button>
						</div>

					</form>

				</>
			}
			{deviceAuth && <DeviceAuth></DeviceAuth>}

		</div>
	);
}
